<template>
    <div class="offers-header" v-if="numberOfOffers > 0">
        <div class="offers-header__icon">
            <svg width="25" height="30" viewBox="0 0 1792 1792">
                <path d="M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"/>
            </svg>
        </div>
        <div class="offers-header__title">
            <strong>{{ numberOfOffers }} {{ $tc('offers_stage.offers_available', numberOfOffers) }}</strong>
        </div>
        <div class="offers-header__button" v-on:click="toggleOffers">
            <span v-if="shouldDisplay">{{ $t('offers_stage.hide_offers') }}</span>
            <span v-if="!shouldDisplay">{{ $t('offers_stage.see_offers') }}</span>
        </div>
    </div>
</template>

<script>
  import Offer from '../models/Offer.ts'

  export default {
    name: 'offersHeader',
    props: [
      'venue',
      'shouldDisplay'
    ],
    data () {
      return {
        numberOfOffers: 0
      }
    },
    methods: {
      toggleOffers () {
        this.$emit('toggle')
      }
    },
    mounted () {
      const allOffers = this.venue.offers

      const visibleOffers = allOffers.filter((offer) => {
        offer = new Offer(offer.data)

        return offer.shouldDisplay(this.$root.dmnOptions.from)
      })

      this.numberOfOffers = visibleOffers.length
    }
  }
</script>



// WEBPACK FOOTER //
// offersHeader.vue?42579783